import styles from "./ReviewDetails.module.scss";
import { IReview } from "../../../models/Review";
import React from "react";
import closeIcon from "../../../assets/images/icons/close-grey.svg";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

interface IReviewDetailsProps {
  review: IReview;
  closePopup: () => void;
}

const ReviewDetails: React.FC<IReviewDetailsProps> = ({ review, closePopup }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.popup}>
        <button className={styles.close} onClick={closePopup}>
          <img src={closeIcon} alt={"close"} />
        </button>
        <h3 className={styles.title}>{t("ReviewDetails")}</h3>
        <div className={styles.row}>
          <div className={styles.item}>
            <h4>{t("MemberName")}</h4>
            <p>
              {review.user.firstName} {review.user.lastName}
            </p>
          </div>
          <div className={styles.item}>
            <h4>{t("Date")}</h4>
            <p>{dayjs(review.createdAt).format("DD/MM/YYYY")}</p>
          </div>
          <div className={styles.item}>
            <h4>{t("Rating")}</h4>
            <p style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <g clip-path="url(#clip0_24037_20280)">
                  <path
                    d="M7.2795 1.91205C7.35287 1.78615 7.45796 1.6817 7.58429 1.6091C7.71063 1.5365 7.85379 1.49829 7.9995 1.49829C8.14521 1.49829 8.28838 1.5365 8.41471 1.6091C8.54105 1.6817 8.64614 1.78615 8.7195 1.91205L10.5828 5.11071L14.2015 5.89471C14.3438 5.92565 14.4756 5.99335 14.5836 6.09107C14.6916 6.18879 14.7721 6.31312 14.8171 6.45166C14.8621 6.59021 14.87 6.73812 14.84 6.88066C14.81 7.0232 14.7432 7.15539 14.6462 7.26405L12.1795 10.0247L12.5528 13.708C12.5676 13.8531 12.544 13.9994 12.4845 14.1325C12.4249 14.2656 12.3315 14.3807 12.2136 14.4664C12.0956 14.5521 11.9573 14.6054 11.8123 14.6209C11.6674 14.6363 11.5209 14.6135 11.3875 14.5547L7.9995 13.0614L4.6115 14.5547C4.47811 14.6135 4.33163 14.6363 4.18667 14.6209C4.04171 14.6054 3.90336 14.5521 3.78542 14.4664C3.66748 14.3807 3.57408 14.2656 3.51455 14.1325C3.45502 13.9994 3.43144 13.8531 3.44617 13.708L3.8195 10.0247L1.35284 7.26471C1.25565 7.15606 1.18867 7.02382 1.15858 6.88119C1.12848 6.73856 1.13633 6.59053 1.18133 6.45188C1.22633 6.31323 1.30692 6.18882 1.41504 6.09105C1.52316 5.99328 1.65504 5.92558 1.7975 5.89471L5.41617 5.11071L7.2795 1.91205Z"
                    fill="#FF8C42"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_24037_20280">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              {review.rating}
            </p>
          </div>
        </div>
        <div className={styles.item}>
          <h4>{t("Comment")}</h4>
          <p>{review.comment}</p>
        </div>
      </div>
    </div>
  );
};

export default ReviewDetails;
